import React, { PureComponent } from 'react';
import { DLAutoComplete } from 'appSrc/components/UI';

export default class FormAutoComplete extends PureComponent {
    render() {
        const { input: { value, onChange, onFocus, onBlur }, meta: { error, dirty } } = this.props;
        var props = {
            ...this.props,
            value,
            onChange,
            onFocus,
            onBlur,
            error: dirty ? error : undefined,
        };

        return (
            <DLAutoComplete { ...props } />
        );
    }
}

DLAutoComplete.defaultProps = {
    className: '',
    style: {},
};
